import {
	FETCH_FLOW_APPLICANT_DETAIL_INIT,
 	FETCH_FLOW_APPLICANT_DETAIL_SUCCESS,
 	FETCH_FLOW_APPLICANT_DETAIL_FAILURE,
	BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_INIT,
	BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_SUCCESS,
	BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_FAILURE,
  FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_INIT,
  FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_SUCCESS,
  FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_FAILURE,
  FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_RESET,
	FLOW_APPLICANT_DETAIL_CREATE_FLOW_INIT,
	FLOW_APPLICANT_DETAIL_CREATE_FLOW_SUCCESS,
	FLOW_APPLICANT_DETAIL_CREATE_FLOW_FAILURE,
	FLOW_APPLICANT_DETAIL_CREATE_FLOW_RESET,
	FLOW_APPLICANT_DETAIL_UPDATE_FLOW_INIT,
	FLOW_APPLICANT_DETAIL_UPDATE_FLOW_SUCCESS,
	FLOW_APPLICANT_DETAIL_UPDATE_FLOW_FAILURE,
	FLOW_APPLICANT_DETAIL_UPDATE_FLOW_RESET,
  FLOW_APPLICANT_DETAIL_TOOGLE_TO_SEND,
	FLOW_APPLICANT_DETAIL_SEND_FLOWS_INIT,
	FLOW_APPLICANT_DETAIL_SEND_FLOWS_SUCCESS,
	FLOW_APPLICANT_DETAIL_SEND_FLOWS_FAILURE,
  FLOW_APPLICANT_DETAIL_RESET
 } from './types';
 import API from './api';

export function reset() {
  return {
    type: FLOW_APPLICANT_DETAIL_RESET,
  };
}

 function fetchApiSuccess(data) {
 	return {
 		type: FETCH_FLOW_APPLICANT_DETAIL_SUCCESS,
 		payload: data,
 	};
 }

 function fetchApiFailure(error) {
 	console.log(error)
 	return {
 		type: FETCH_FLOW_APPLICANT_DETAIL_FAILURE,
 		payload: error,
 	};
 }

 function fetchApiInit() {
 	return {
 		type: FETCH_FLOW_APPLICANT_DETAIL_INIT,
 	};
 }

 export function fetchFlowApplicantDetailApi(filters) {
 	return async (dispatch) => {
 		dispatch(fetchApiInit());
 		try {
 			let data = await API.data.getAll(filters);
 			dispatch(fetchApiSuccess(data));
 		} catch (error) {
 			dispatch(fetchApiFailure(error));
 		}
 	};
 }

 /* background fetch */

 function backgroundFetchApiSuccess(data) {
  return {
    type: BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_SUCCESS,
    payload: data,
  };
 }

 function backgroundFetchApiFailure(error) {
  console.log(error)
  return {
    type: BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_FAILURE,
    payload: error,
  };
 }

 function backgroundFetchApiInit() {
  return {
    type: BACKGROUND_FETCH_FLOW_APPLICANT_DETAIL_INIT,
  };
 }

 export function backgroundFetchFlowApplicantDetailApi(filters) {
  return async (dispatch) => {
    dispatch(backgroundFetchApiInit());
    try {
      let data = await API.data.getAll(filters);
      dispatch(backgroundFetchApiSuccess(data));
    } catch (error) {
      dispatch(backgroundFetchApiFailure(error));
    }
  };
 }

 /* Validate Flow (Async) */

function validateFlowApiSuccess(data) {
  return {
    type: FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_SUCCESS,
    payload: data
  };
}

function validateFlowApiFailure(error) {
  return {
    type: FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_FAILURE,
    payload: error
  };
}

function validateFlowApiInit() {
  return {
    type: FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_INIT
  };
}

export function validateFlow(flowData) {
  return async dispatch => {
    dispatch(validateFlowApiInit());
    try {
      const resp = await API.data.validateFlow(flowData);
      return dispatch(validateFlowApiSuccess(resp));
    } catch (error) {
      return dispatch(validateFlowApiFailure(error));
    }
  };
}

export function validateFlowApiReset() {
  return {
    type: FLOW_APPLICANT_DETAIL_VALIDATE_FLOW_RESET
  };
}

 /* Create Flow (Async) */

function createFlowApiSuccess(data) {
  return {
    type: FLOW_APPLICANT_DETAIL_CREATE_FLOW_SUCCESS,
    payload: data
  };
}

function createFlowApiFailure(error) {
  return {
    type: FLOW_APPLICANT_DETAIL_CREATE_FLOW_FAILURE,
    payload: error
  };
}

function createFlowApiInit() {
  return {
    type: FLOW_APPLICANT_DETAIL_CREATE_FLOW_INIT
  };
}

export function createFlow(flowData) {
  return async dispatch => {
    dispatch(createFlowApiInit());
    try {
      const resp = await API.data.createFlow(flowData);
      return dispatch(createFlowApiSuccess(resp));
    } catch (error) {
      return dispatch(createFlowApiFailure(error));
    }
  };
}

export function createFlowApiReset() {
  return {
    type: FLOW_APPLICANT_DETAIL_CREATE_FLOW_RESET
  };
}

 /* Update Flow (Async) */

function updateFlowApiSuccess(data,flowRequest) {
  if(flowRequest) {
    data.flowId = flowRequest.id;
  }
  return {
    type: FLOW_APPLICANT_DETAIL_UPDATE_FLOW_SUCCESS,
    payload: data
  };
}

function updateFlowApiFailure(error) {
  return {
    type: FLOW_APPLICANT_DETAIL_UPDATE_FLOW_FAILURE,
    payload: error
  };
}

function updateFlowApiInit() {
  return {
    type: FLOW_APPLICANT_DETAIL_UPDATE_FLOW_INIT
  };
}

export function updateFlow(flowData) {
  return async dispatch => {
    dispatch(updateFlowApiInit());
    try {
      const resp = await API.data.updateFlow(flowData);
      return dispatch(updateFlowApiSuccess(resp,flowData.flowRequest));
    } catch (error) {
      return dispatch(updateFlowApiFailure(error));
    }
  };
}

export function updateFlowApiReset() {
  return {
    type: FLOW_APPLICANT_DETAIL_UPDATE_FLOW_RESET
  };
}

/* toogle to send later */

export function toogleToSendLater(flow,action) {
  return {
    type: FLOW_APPLICANT_DETAIL_TOOGLE_TO_SEND,
    payload: {
      modifiedFlow: {...flow},
      action: action,
      comment: ""
    }
  };
}

 /* Send Flows (Async) */

function sendFlowsApiSuccess(data) {
  return {
    type: FLOW_APPLICANT_DETAIL_SEND_FLOWS_SUCCESS,
    payload: data
  };
}

function sendFlowsApiFailure(error) {
  return {
    type: FLOW_APPLICANT_DETAIL_SEND_FLOWS_FAILURE,
    payload: error
  };
}

function sendFlowsApiInit() {
  return {
    type: FLOW_APPLICANT_DETAIL_SEND_FLOWS_INIT
  };
}

export function sendFlows(flows) {
  return async dispatch => {
    dispatch(sendFlowsApiInit());
    try {
      const resp = await API.data.sendFlows(flows);
      return dispatch(sendFlowsApiSuccess(resp));
    } catch (error) {
      return dispatch(sendFlowsApiFailure(error));
    }
  };
}

 export function downloadMopFile(path) {
  return async (dispatch) => {
    try {
      let data = await API.data.handleDownloadMopFile(path);
    } catch (error) {}
  };
}




// WEBPACK FOOTER //
// ./source/client/actions/flow_applicant_detail/index.js